import KendoSpreadsheet from './KendoSpreadsheet'
import KendoSpreadsheetSheet from './KendoSpreadsheetSheet'
import KendoSpreadsheetInstaller from './kendo-spreadsheet-installer'

export { KendoSpreadsheet, KendoSpreadsheet as Spreadsheet, KendoSpreadsheetSheet, KendoSpreadsheetSheet as SpreadsheetSheet, KendoSpreadsheetInstaller, KendoSpreadsheetInstaller as SpreadsheetInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/index.js